'use strict';

import React, { Component } from 'react';

import MapLeaflet from  '../../../global/mapReactLibrary/MapLeaflet.jsx';
import { Card } from '@material-ui/core';
//var GoogleApiComponent = require('../mapReactLibrary/GoogleApiComponent.js')
var Moment = require('moment'),
    $ = require('jquery');



class MapPAYGO extends Component{

    state = {        
            currentAddress: 'Paris, France',
            mapCoordinates: {
                lat: 48.856614,
                lng: 2.3522219
            },
            paygoMapList: [],
    }
    componentDidMount = () => {
        //Get Data From paygo User
        console.log("Token User : ", this.props.tokenUser);
        var methodName = 'paygoMap class';
        var url = "/box/paygomapList";
        var testTime = Moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        console.log('[DEBUG], ', methodName, ',URL :, ', url, ' & ', testTime);

        this.serverRequest = $.get(url, function(result) {
            console.log('[INFO],  reception des données  des utilisateur de PAYGO ');
            console.log(result);
            var paygoUserTmp = [];
            var lat = 0.0;
            var long = 0.0;
            var nbOfData = 0;
            try {
                var data = result; //var data = JSON.parse(result);
                console.log(result);
                console.log(data);
                console.log(data.userList);

                for (var i = 0; i < data.userList.length; i += 1) {
                    console.log(data.userList[i]);

                    var d = new Date();
                    var offSet = d.getTimezoneOffset();

                    var nextP = Date.parse(data.userList[i].timeGps);
                    var nextPP = new Date(nextP - 1000 * 60 * offSet);


                    paygoUserTmp.push({
                        boxId: data.userList[i].boxId,
                        longitude: data.userList[i].longitude,
                        latitude: data.userList[i].latitude,
                        altitude: data.userList[i].altitude,
                        timeGps: nextPP.toISOString(),
                        status: data.userList[i].status,
                        nextCode: data.userList[i].nextCode
                    });
                    lat = lat + data.userList[i].latitude;
                    long = long + data.userList[i].longitude;
                    nbOfData ++;
                }
            } catch (e) {
                // les instructions utilisées pour gérer les
                // exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                return;
            }
            console.log('paygoMapList');
            console.log(paygoUserTmp);
            if ( nbOfData === 0 ){
              lat = this.state.mapCoordinates.lat;
              long = this.state.mapCoordinates.lng;
            } else {
              lat = lat/nbOfData;
              long = long/nbOfData;
            }
            var mapCoordinates = {
                lat: lat,
                lng: long,
            };
            this.setState({paygoMapList: paygoUserTmp,mapCoordinates:mapCoordinates});
        }.bind(this));
    }
    componentWillUnmount = () => {
        this.serverRequest.abort();
    }
    render() {
        console.log('[INFO], render fonction Map PAYG');
        var gooProps = window.google;
        console.log('[INFO], render fonction Map PAYG, with paygoMapList :');
        console.log(this.state.paygoMapList);
        const style = {
            width: '100%',
            height: '550px'
        }
        const position = [this.state.mapCoordinates.lat, this.state.mapCoordinates.lng]

        return (
            <Card style={style}>
                <MapLeaflet lat={this.state.mapCoordinates.lat} lng={this.state.mapCoordinates.lng} paygoMapList={this.state.paygoMapList}/>
            </Card>
        )
    }
};
export default MapPAYGO;
